import request from 'config/apiConfig';
import { uploadStatus } from 'config/status';

export const getVideoList = (payload: { marketerId: string; status: string; page: number; search?: string }) => {
  const contentStatus = uploadStatus[payload.status as keyof typeof uploadStatus];
  return request.get(`playlist/contents/marketer`, {
    params: {
      id: payload.marketerId,
      status: contentStatus,
      size: 12,
      sort: 'created,desc',
      page: payload.page,
      q: payload.search || undefined
    }
  });
};

export const postUploadContent = (payload: any) => {
  return request.post(`playlist/contents`, payload);
};

export const putUploadContent = (id: string, data: any) => {
  return request.put(`playlist/contents/${id}/info`, data);
};

export const putUploadTags = (id: string, data: any) => {
  return request.put(`playlist/contents/${id}/tags`, data);
};

export const putMediaContent = (payload: FormData, id: string) => {
  return request.put(`content/assets/content/${id}`, payload);
};

export const putModerationStatus = ({ id, type, message }: { id: string; type: string; message?: string }) => {
  return request.put(`moderation/moderations/${id}/${type}`, { ...(message && { message }) });
};

export const putReviewStatus = ({ contentId, message }: { contentId: string; message?: string }) => {
  return request.post(`content/revisions`, { contentId, message });
};

export const putUpdateCTA = (id: string, ctaId: string) => {
  return request.put(`playlist/contents/${id}/cta`, { cta: ctaId });
};

export const postConversionToCTA = (data: any) => {
  return request.post(`/conversion/ctas`, data);
};

export const addTagToCategory = (tagId: string, categoryId: string) => {
  return request.put(`/playlist/tags/${tagId}/category`, { category: categoryId });
};

export const createTagWithCategory = (tag: string, categoryId: string) => {
  return request.post(`/playlist/tags`, { name: tag, category: categoryId });
};
